export const obtenerSegmentosFiltrados = (listaDeActivosFiltrados, listaDeSegmentos) => {
    let segmentosFiltrados = [];
    listaDeActivosFiltrados.forEach(activo =>{
        const segmentos = listaDeSegmentos.filter(segmento => segmento.informacionDeLosPadres.activoAsociado.nombre === activo.informacionGeneral.nombre.valor);
        segmentosFiltrados =  segmentosFiltrados.concat(segmentos);
    });
    return segmentosFiltrados
}